/* Shopify Manager – Hextom | JPY rounding to nearest 1,000 (Fix: Cart Selectors) */
(() => {
  try {
    const NS = "sm";
    const CFG_ID = "sm-jpy-config";
    if (window[`${NS}JpyRounderMounted`]) return;
    window[`${NS}JpyRounderMounted`] = true;

    const addStyles = () => {
      const styleId = "sm-jpy-styles";
      if (document.getElementById(styleId)) return;
      const css = `
        .ht-money[data-sm-hide-jpy="1"] { display: none !important; }
        .sm-jpy-alt { display: inline; text-decoration: inherit; }
      `;
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = css;
      document.head.appendChild(style);
    };

    // ---- config ----
    const cfgEl = () => document.getElementById(CFG_ID);
    const getCfg = () => {
      const el = cfgEl(); if (!el) return null;
      return {
        enable: el.dataset.smEnable === "true",
        target: (el.dataset.smTargetCurrency || "JPY").toUpperCase(),
        unit: parseInt(el.dataset.smRoundingUnit || "1000", 10),
        mode: el.dataset.smRoundingMode || "nearest",
        symbol: el.dataset.smSymbol || "¥",
        symbolPlacement: el.dataset.smSymbolPlacement || "before",
        suffix: el.dataset.smSuffix || "JPY",
        spaceSymAmt: el.dataset.smSpaceBetweenSymbolAndAmount === "true",
        spaceBeforeSuffix: el.dataset.smSpaceBeforeSuffix !== "false",
        decimals: parseInt(el.dataset.smDecimals || "0", 10),
        scopeSelectors: el.dataset.smScopeSelectors || "#MainContent, .drawer, #CartDrawer, body",
        currencyProbe: el.dataset.smCurrencyProbe || "",
        pollMs: parseInt(el.dataset.smPollMs || "700", 10),
        debug: el.dataset.smDebug === "true"
      };
    };

    // ---- helpers ----
    const roundToUnit = (n, u, m) => {
      const q = n / u;
      return m === "up"   ? Math.ceil(q) * u
           : m === "down" ? Math.floor(q) * u
           : Math.round(q) * u;
    };

    const parseAmountText = (txt) => {
      if (!txt) return null;
      const s = String(txt).replace(/[\s\u00A0]+/g, " ").trim();
      if (!/JPY|¥/.test(s)) return null;

      let m =
        s.match(/¥\s*([0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)/) ||
        s.match(/([0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)\s*JPY\b/) ||
        s.match(/([0-9]{1,3}(?:,[0-9]{3}){1,})(?:\.[0-9]+)?/);
      if (!m) return null;
      const num = Number(m[1].replace(/,/g, ""));
      return Number.isFinite(num) ? num : null;
    };

    const formatJPY = (n, c) => {
      const base = Number.isFinite(n) ? n : 0;
      const amt = (c.decimals === 0)
        ? Math.round(base).toLocaleString("ja-JP")
        : Number(base).toLocaleString("ja-JP", {
            minimumFractionDigits: c.decimals,
            maximumFractionDigits: c.decimals
          });
      const symAmt = c.symbolPlacement === "before"
        ? c.symbol + (c.spaceSymAmt ? " " : "") + amt
        : amt + (c.spaceSymAmt ? " " : "") + c.symbol;
      return c.suffix
        ? symAmt + (c.spaceBeforeSuffix ? " " : "") + c.suffix
        : symAmt;
    };

    const isCheckout = () => /\/checkouts\//.test(location.pathname);

    const scopes = (c) =>
      c.scopeSelectors
        .split(",")
        .map(s => s.trim())
        .filter(Boolean)
        .map(sel => document.querySelector(sel))
        .filter(Boolean);

    const $$ = (root, sel) => {
      try { return root.querySelectorAll(sel); } catch { return []; }
    };

    const collectMoneyNodes = (c) => {
      const roots = scopes(c);
      const set = new Set();
      // [수정] 장바구니 관련 선택자 추가
      const sel =
        ".price .ht-money," +
        ".cart-drawer__total-price .ht-money," +
        ".cart__summary-total-price .ht-money," +
        ".totals__subtotal-value .ht-money," +
        ".totals__value .ht-money," +
        ".cart-subtotal__price .ht-money," +
        ".cart-item__price .ht-money," +
        ".cart-item__discounted-prices .ht-money";

      roots.forEach(r => {
        if (!r) return;
        $$(r, sel).forEach(n => set.add(n));
      });
      return Array.from(set);
    };

    // ---- Hextom TMS 통화 코드 읽기 ----
    let lastCurrency = null;

    const readFromTms = async () => {
      try {
        if (window.tms?.selectorApi?.currency?.code)
          return String(window.tms.selectorApi.currency.code).toUpperCase();
        if (window.tms?.currencyConverterApi?.currency?.toCurrency?.code)
          return String(window.tms.currencyConverterApi.currency.toCurrency.code).toUpperCase();
        if (window.tms?.currency?.code)
          return String(window.tms.currency.code).toUpperCase();
      } catch {}
      return null;
    };

    const readFromProbe = (c) => {
      if (!c.currencyProbe) return null;
      const el = document.querySelector(c.currencyProbe);
      const t = el
        ? (el.textContent || el.getAttribute("data-currency") || "").toUpperCase().trim()
        : "";
      const m = t.match(/\b([A-Z]{3})\b/);
      return m ? m[1] : (t === "JPY" ? "JPY" : null);
    };

    const inferFromSample = () => {
      const s = document.querySelector(".price,.price-item,.money,.ht-money");
      if (!s) return null;
      const t = (s.textContent || "").toUpperCase();
      return /\bJPY\b/.test(t) ? "JPY" : null;
    };

    const getCurrency = async (c) =>
      await readFromTms() || readFromProbe(c) || inferFromSample() || null;

    // ---- alt 관리 ----
    const ALT_CLASS = "sm-jpy-alt";

    const getNodeId = (n) => {
      if (!n.dataset.smJpyNodeId) {
        n.dataset.smJpyNodeId = `smjpy-${Math.random().toString(36).slice(2)}`;
      }
      return n.dataset.smJpyNodeId;
    };

    const ensureAlt = (n) => {
      const id = getNodeId(n);
      let alt = n.parentElement?.querySelector(`.${ALT_CLASS}[data-for-id="${id}"]`);
      if (!alt) {
        alt = document.createElement("span");
        alt.className = ALT_CLASS;
        alt.setAttribute("data-for-id", id);
        n.insertAdjacentElement("afterend", alt);
      }
      n.setAttribute("data-sm-hide-jpy", "1");
      n.setAttribute("aria-hidden", "true");
      return alt;
    };

    const removeAltAll = () => {
      document.querySelectorAll("." + ALT_CLASS).forEach(e => e.remove());
      document
        .querySelectorAll('.ht-money[data-sm-hide-jpy="1"]')
        .forEach(e => {
          e.removeAttribute("data-sm-hide-jpy");
          e.removeAttribute("aria-hidden");
        });
    };

    // ---- 메인 적용 로직 ----
    const applyJPY = () => {
      const c = getCfg(); if (!c || !c.enable || isCheckout()) return;

      document.querySelectorAll(".sm-cny-alt").forEach(e => e.remove());
      document.querySelectorAll('.ht-money[data-sm-hide-cny="1"]').forEach(e => {
          e.removeAttribute("data-sm-hide-cny");
          e.removeAttribute("aria-hidden");
      });

      const nodes = collectMoneyNodes(c);
      c.debug && console.debug("[sm] JPY ht-money nodes:", nodes.length);

      nodes.forEach(n => {
        const raw = n.getAttribute("data-ht-price-converted-to") || n.textContent || "";
        const baseNum = parseAmountText(raw);
        if (baseNum == null) return;
        if (!Number.isFinite(baseNum) || Math.abs(baseNum) > 1e10) return;

        const rounded = roundToUnit(baseNum, c.unit, c.mode);
        const out = formatJPY(rounded, c);

        const alt = ensureAlt(n);
        if (alt.textContent !== out) alt.textContent = out;
      });
    };

    const cycle = async () => {
      const c = getCfg(); if (!c || !c.enable) return;
      const code = await getCurrency(c);
      if (code && code !== lastCurrency) lastCurrency = code;
      if (lastCurrency === c.target) applyJPY();
      else removeAltAll();
    };

    const boot = () => {
      const c = getCfg(); if (!c || !c.enable) return;
      addStyles();
      cycle();
      scopes(c).forEach(r => {
        if (!r) return;
        const mo = new MutationObserver(() => setTimeout(cycle, 50));
        mo.observe(r, { childList: true, subtree: true, characterData: true });
      });
      setInterval(cycle, c.pollMs || 700);
      window.smJpyRounderReapply = cycle;
    };

    if (document.readyState === "complete" || document.readyState === "interactive") boot();
    else document.addEventListener("DOMContentLoaded", boot);
  } catch (e) {
    console && console.warn && console.warn("sm-jpy-rounder error:", e);
  }
})();